<div id="error-404">
  <picture>
    <source media="(min-width: 767px) and (max-width: 1499px)" srcset="assets/images/404-desktop.png">
    <img id="icon-404" src="assets/images/404-mobile.png" alt="404 We’re sorry, something’s wrong. 
    This page doesn’t exist." width="100%">
  </picture>
  <div class="wrapper">
    <div class="wrapper-img"><img src="assets/images/404-icon.png" alt="404"></div>
    <div class="wrapper-txt">
      <h2>{{cfetLabels.cfet_page_not_found.pnf_description}}<br>
        {{cfetLabels.cfet_page_not_found.pnf_point1}}</h2>
    </div>
  </div>
</div>